import { CALCULATE_POSTCODE, RESPONSE_ERROR, NOT_FOUND_ERROR } from '../actions/types';

const initialState = {
    status: true
};
const postcode = (state = initialState, action) => {
    switch (action.type) {
        case CALCULATE_POSTCODE:
            return { ...initialState, ...action.payload };
        case RESPONSE_ERROR:
            return { status: false }
        case NOT_FOUND_ERROR:
            return { ...state, status: true }
        default:
            return state;
    }
};
export default postcode;
